import { RadioEprEvent } from 'estensa-module';
import { ISourceItemDataExtended } from './rest.models';
export enum PatientHistoryStatusDTO {
    Reported,
    Approved,
    DigitallySigned
}

export interface ReportHistoryRequestDTO {
    idPatient: string; // guid
    patientId: string | null;
    issuer: string | null;
    idSource: string | null;
}

export interface ReportHistoryDTO {
    reports: ReportPatientHistoryDTO[];
    patient: PatientPatientHistoryDTO;
}
export interface ReportPatientHistoryDTO {
    id: string; // guid
    text: string | null;
    executionDate?: Date | null;
    reportDate: Date | null;
    approvalDate?: Date | null;
    digitallySigningDate?: Date | null;
    examinations: ExaminationPatientHistoryDTO[];
    referringPhysicians: UserPatientHistoryDTO[];
    status: PatientHistoryStatusDTO;
    sopInstanceUID: string; // reportKey
    pdfExist: boolean;
    isExternal?: boolean | null;
    isImported?: boolean | null;
    imageAvailability?: boolean | null;
    addendumNumer?: number | null;
}

export interface PatientPatientHistoryDTO {
    id: string; // guid
    surname: string | null;
    name: string | null;
    patientId: string | null;
    otherPatientId: string | null;
    birthDate?: Date | null;
    taxCode: string | null;
    sex: string | null; // description
    issuer: string | null;
}

export interface ExaminationPatientHistoryDTO {
    id: string; // guid
    provenance: string | null;
    businessUnit: string | null;
    exam: string | null;
    modality: string | null;
    plannedDate?: Date | null;
    admissionDate?: Date | null;
    executionDate?: Date | null;
    imageAvailability?: boolean | null;
    examNumber: string | null;
    reasonForStudy: string | null;
    hospitalizationNumber: string | null;
    admissionNumber: string | null;
    accessionNumber: string | null;
    studyInstanceUID: string;
    idEvent: string; // guid
    httpPacs: string | null;
    iconGroup: string | null;
    iconName: string | null;
}
export interface UserPatientHistoryDTO {
    fullName: string | null;
    role: string | null;
}

export interface IRadioEprEventEx extends RadioEprEvent {
    selected: boolean;
    dateString: string;
    reportDateString: string;
}

export interface ReportHistoryActorErrors {
    actorDetail: ISourceItemDataExtended | string | null;
    error: string | any;
}

export enum HistoryState {
    LOADING = 'LOADING',
    SUCCESS = 'SUCCESS',
    SUCCESS_NO_RESULT = 'SUCCESS_NO_RESULT',
    INCOMPLETE = 'INCOMPLETE',
    ERROR = 'ERROR'
}


